/**
 * Hilfsfunktionen rund um Standnummern (Feld `boothNumber` am Lieferanten, Format "12, 13").
 */

export function parseBoothNumbers(value) {
  if (value == null) {
    return []
  }

  return [...new Set(String(value).split(/[,;/\s]+/).map(s => s.trim()).filter(s => s.length > 0))]
}

export function formatBoothNumbers(numbers) {
  return numbers.join(', ')
}

export function supplierDisplayName(supplier) {
  return supplier.supplierGroup || supplier.companyName || supplier.id
}

function compareNumbers(a, b) {
  const na = parseInt(a, 10)
  const nb = parseInt(b, 10)

  if (!isNaN(na) && !isNaN(nb)) {
    return na - nb
  }

  return String(a).localeCompare(String(b))
}

/** Alle im Plan vorhandenen Nummern mit Beschriftung, numerisch sortiert. */
export function planNumbers(plan) {
  const items = plan.stands.map(s => ({ number: s.number, label: s.label || null, kind: 'stand' }))

  for (const area of plan.areas) {
    if (area.number) {
      items.push({ number: area.number, label: area.label || null, kind: area.kind })
    }
  }

  return items.sort((a, b) => compareNumbers(a.number, b.number))
}

/**
 * Standnummer → Zuweisung. Bei Mehrfachbelegung wird der erste Lieferant (alphabetisch) gezeigt und
 * die Zuweisung als Konflikt markiert.
 */
export function buildAssignments(suppliers, { apiUri }) {
  const byNumber = {}

  for (const supplier of suppliers) {
    for (const number of parseBoothNumbers(supplier.boothNumber)) {
      (byNumber[number] = byNumber[number] || []).push(supplier)
    }
  }

  const assignments = {}

  for (const number of Object.keys(byNumber)) {
    const list = byNumber[number].sort((a, b) => supplierDisplayName(a).localeCompare(supplierDisplayName(b)))
    const supplier = list[0]

    assignments[number] = {
      supplierId: supplier.id,
      name: supplierDisplayName(supplier),
      logoUrl: supplier.logoId != null ? `${apiUri}/attachment/${supplier.logoId}/content` : null,
      darkBackground: !!supplier.darkBackground,
      productCount: supplier.productCount,
      state: supplier.state,
      conflict: list.length > 1,
      suppliers: list
    }
  }

  return assignments
}
